/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formtype_Options_Mediaenquiry2Inputs */

const ja_contact_formtype_options_mediaenquiry2 = /** @type {(inputs: Contact_Formtype_Options_Mediaenquiry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご取材・メディア掲載・講演に関するお問い合わせ`)
};

const en_contact_formtype_options_mediaenquiry2 = /** @type {(inputs: Contact_Formtype_Options_Mediaenquiry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press / Media Enquiry`)
};

/**
* | output |
* | --- |
* | "Press / Media Enquiry" |
*
* @param {Contact_Formtype_Options_Mediaenquiry2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formtype_options_mediaenquiry2 = /** @type {((inputs?: Contact_Formtype_Options_Mediaenquiry2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formtype_Options_Mediaenquiry2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formtype_options_mediaenquiry2(inputs)
	return en_contact_formtype_options_mediaenquiry2(inputs)
});
export { contact_formtype_options_mediaenquiry2 as "contact_formType_options_mediaEnquiry" }